import React from "react"
import HeadingM from "../shared/HeadingM"
import ContactFormBase from "../shared/contact/ContactForm"

const ContactForm = () => (
  <>
    <HeadingM title="フォーム" target="sutea" />
    <ContactFormBase target="sutea" />
  </>
)

export default ContactForm
